import React, { FC } from 'react';
import { EmploymentData } from 'contexts/FormProvider';
import EditIcon from '@mui/icons-material/Edit';
import { useContent, useContentContext } from '@qbe/dfc-content';

import { useTrackSummary } from 'hooks/useAnalytics';
import { IconButton, useTheme, styled } from '@qbe/ads-core';
import { FormCard, DetailedList } from '@qbe/ads-blocks-forms';
import FormSpacer from 'components/FormSpacer/FormSpacer';
import { List } from '@qbe/ads-blocks-forms/src/DetailedList/DetailedList.type';

type Props = {
  field: EmploymentData;
  onEdit: () => void;
};

const StyledDetailedList = styled(DetailedList)`
  .ListGroup__list-wrapper > .ListGroup__list-label--multiple span {
    font-weight: 100 !important;
    font-size: 1rem;
  }

  .ListGroup__list > p {
    font-weight: 700;
    font-size: 1rem;
  }
`;

const EmploymentPreview: FC<Props> = ({ field, onEdit }) => {
  const { palette } = useTheme();

  const { getTextContent } = useContent({
    context: useContentContext(),
  });

  // Localized content helper
  const getSummaryLabel = (key: string) => getTextContent(`Employment.summary.${key}`);

  const entry = (contentKey: string, value: string): List => ({
    id: `${field.id}-${contentKey}`,
    name: `${field.id}-${contentKey}`,
    label: getSummaryLabel(contentKey),
    value,
  });

  // to add a new field, add the object, with its key and value.
  const details: List[] = [
    { key: 'employmentType', value: field.employmentType },
    { key: 'employerName', value: field.employerName },
    { key: 'occupation', value: field.occupation },
    { key: 'salary', value: `$${field.salary}` },
    { key: 'contactPersonNumber', value: field.contactPersonNumber },
    { key: 'contactPerson', value: field.contactPerson },
  ]
    .filter((item) => item.value)
    .map((item) => entry(item.key, item.value as string));

  useTrackSummary('employmentSummary');

  return (
    <>
      <FormSpacer type="pagesection" />
      <FormCard variant="content">
        <StyledDetailedList
          variant="multiple"
          title={field.employerName}
          list={details}
          titleComponents={
            <IconButton iconProps={{ muiIcon: EditIcon, color: palette.action.active }} onClick={onEdit} />
          }
        />
      </FormCard>
    </>
  );
};

export default EmploymentPreview;
